module.exports = __webpack_public_path__ + "static/media/jardinrodin2.056726f9.JPG";